import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectSindicatoComponent } from './select-sindicato.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [SelectSindicatoComponent],
  imports: [
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatOptionModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatMenuModule,
  ],
  exports: [SelectSindicatoComponent],
})
export class SelectSindicatoModule {}
